// src/components/PriceDisplay.js

import React, { useState, useEffect, useRef } from 'react';
import { Box, Snackbar, Typography, IconButton, TextField, Button, Link, Menu, MenuItem, } from '@mui/material';
import EggIcon from '@mui/icons-material/Egg';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import { motion } from 'framer-motion';
import axios from 'axios';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import TopCryptoLoans from './TopCryptoLoans';
import PopularLinks from './PopularLinks';
import PaymentPopup from './PaymentPopup';
import AuthPopup from './AuthPopup';
import UsdVsBtcComparison from './UsdVsBtcComparison';
import UsdToBtcConverter from './UsdToBtcConverter';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import EducationLinks from './EducationLinks';
import CryptoPurchaseFinder from './CryptoPurchaseFinder';
import BuyCryptoOnline from './BuyCryptoOnline';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LenderBorrowerApply from './LenderBorrowerApply';
import NewsAndBlogs from './NewsAndBlogs';
import PlayCoinGames from './PlayCoinGames';
import AAdsBanner from './AAdsBanner';
import DogSprite from './DogSprite';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import InstallAppButton from './InstallAppButton';
import Dashboard from './Dashboard'; // Make sure the path is correct
import { useAuth } from '../contexts/AuthContext';

const AUDIO_BASE_URL = "https://media.satoshiadvance.com/audio";


const TickerTapeComponent = ({ content }) => {
  return (
    <TickerTape>
      <TickerContent>
        {content}
      </TickerContent>
    </TickerTape>
  );
};


const tickerString = `
Hello, Good day, and thanks for Visiting SatoshiAdvance - Home for Crypto Loans, news, events and more! •
Wear headphones & Explore!
Bitcoin All Time High $126,125 October 6th, 2025! •
Borrow, Lend, Shop, & more in Dogecoin, BTC, ETH •
Ethereum All Time High $4,946 August, 2025! •
DOGE All time High $0.74 May, 2021! •
As of 2025, 10,000 Satoshi's are worth about $10 USD! •
Play Retro Bit Dogs! learn about dog breeds & download your favorite card•
`;

// 2) Use JSX to display ticker text + Egg icon
const tickerContent = (
  <>
    {tickerString}
    <Tooltip
      arrow
      componentsProps={{
        tooltip: {
          sx: { fontSize: '1rem' } // increase font size as needed
        }
      }}
      title={
        <Typography variant="body1">
          Enable Purple (Juicy Plum) Theme! <br />
          1. In Microsoft Edge, click the three-dot menu in the top-right corner <br />
          2. Tap "Settings" <br />
          3. In the Upper Left, tap the three-line menu option <br />
          4. Choose "Appearance" <br />
          5. Under "Theme" or "Theme color," select "Juicy plum"
        </Typography>
      }
    >
      <EggIcon
        sx={{
          color: '#cc66ff',             // more purple
          fontSize: '1.4rem',            // slightly larger size
          verticalAlign: 'middle',
          filter: 'drop-shadow(0 0 2px #cc66ff)', // subtle glow
          marginLeft: '8px',
          cursor: 'pointer',
        }}
      />
    </Tooltip>
  </>
);

// Retro button used for the floating corner buttons
// Now sized about 40% smaller than before
const RetroSquareButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'compact'
})(({ theme, compact }) => ({
  // Base styles (tablet)
  width: compact ? '24px' : '36px',
  height: compact ? '24px' : '36px',
  backgroundColor: '#1a237e',
  border: '2px solid #FFFFFF',
  color: '#FFFFFF',
  fontSize: compact ? '0.8rem' : '1.2rem',
  fontFamily: "'Press Start 2P', cursive",
  textShadow: `
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000
  `,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#283593',
  },
  position: 'relative',
  zIndex: 1,

  // Mobile styles - 250% bigger for better touch interaction
  [theme.breakpoints.down('sm')]: {
    width: compact ? '60px' : '90px',  // 250% bigger than before (was 12px/16px)
    height: compact ? '60px' : '90px',
    fontSize: compact ? '1.2rem' : '1.8rem',  // Larger text for readability
    border: '3px solid #FFFFFF',  // Thicker border for better visibility
  },

  // Desktop/widescreen styles (100% bigger)
  [theme.breakpoints.up('lg')]: {
    width: compact ? '48px' : '72px',
    height: compact ? '48px' : '72px',
    fontSize: compact ? '1.8rem' : '2.6rem',
    border: '6px solid #FFFFFF',
  }
}));

const Separator = styled('span')({
  color: '#fff',
  margin: '0 8px',
});

// Add these with your other styled components
const TickerTape = styled('div')(({ theme }) => ({
  width: '80%',
  margin: '0 auto',
  marginTop: '10px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  position: 'relative',
  fontFamily: "'Roboto', sans-serif",
  fontSize: '19px',
  color: '#FFFFFF',
  padding: '8px 0',
  backgroundColor: '#283593',
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    fontSize: '16px'
  }
}));

const TickerContent = styled('div')({
  display: 'inline-block',
  animation: 'ticker 45s linear infinite',
  paddingLeft: '100%',
  '& a': {
    color: '#00BFFF',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#00BFFF'
    }
  },
  '&:hover': {
    animationPlayState: 'paused'
  },
  '@keyframes ticker': {
    '0%': {
      transform: 'translateX(0)'
    },
    '100%': {
      transform: 'translateX(-100%)'
    }
  }
});

const HeaderTitleMobile = styled(Typography)(({ theme }) => ({
  fontFamily: "'Press Start 2P', cursive",
  color: '#FFFFFF',
  fontSize: '1.5rem',
  textAlign: 'center',
  marginTop: '10px',
  display: 'block',  // Always render it by default
  [theme.breakpoints.up('md')]: {
    display: 'none'  // Hide on medium and larger screens
  }
}));

const RetroButton = styled(Button)(({ theme }) => ({
  fontFamily: "'Press Start 2P', cursive",
  color: '#FFFFFF',
  backgroundColor: 'transparent',
  border: '2px solid #FFFFFF',
  borderRadius: '4px',
  padding: '4px 12px',
  fontSize: '0.7rem',
  textTransform: 'none',
  minWidth: 'auto',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    boxShadow: '0 0 10px #00BFFF'
  },
  transition: 'all 0.3s ease'
}));

// Container for the four retro buttons at the top of the page
const ButtonGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '0.25in',
  justifyContent: 'center',
  width: 'fit-content',
  margin: '10px auto',
}));

const CompactButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',                  // Reduced gap from 8px
  alignItems: 'center',
  justifyContent: 'center',    // Center the buttons
}));

const ButtonLabel = styled(Typography)({
  color: '#FFFFFF',
  fontFamily: "'Roboto', sans-serif",
  fontSize: '0.7rem',
  marginTop: '4px',
});

const NeonControllerIcon = ({ neonColor }) => (
  <SportsEsportsIcon
    sx={{
      fontSize: { xs: '1.6rem', md: '2rem', lg: '2.4rem' },
      color: neonColor.color,
      filter: `drop-shadow(0 0 4px ${neonColor.glow}) drop-shadow(0 0 8px ${neonColor.glow})`,
      marginTop: '4px',
    }}
  />
);

const PaymentButton = ({ onClick, compact, neonColor }) => {
  const payAudioRef = useRef(null);

  const playPaySound = (e) => {
    e.preventDefault();
    if (payAudioRef.current) {
      payAudioRef.current.currentTime = 0;
      payAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playPaySound(e);
    onClick(); // This triggers the popup
  };

  return (
    <>
      <audio ref={payAudioRef} src={`${AUDIO_BASE_URL}/PayButton.mp3`} />
      <Box
        onClick={playPaySound}
        onDoubleClick={handleDoubleClick}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <RetroSquareButton compact={compact}>D</RetroSquareButton>
        {!compact && <ButtonLabel>Search</ButtonLabel>}
        {!compact && neonColor && <NeonControllerIcon neonColor={neonColor} />}
      </Box>
    </>
  );
};

const HeaderCompactLeftButton = () => {
  const wheelAudioRef = useRef(null);

  const playWheelSound = (e) => {
    e.preventDefault();
    if (wheelAudioRef.current) {
      wheelAudioRef.current.currentTime = 0;
      wheelAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playWheelSound(e);
    window.open('/bitwheel', '_blank');
  };

  return (
    <>
      <audio ref={wheelAudioRef} src={`${AUDIO_BASE_URL}/WheelButton.mp3`} />
      <HeaderCompactButton
        onClick={playWheelSound}
        onDoubleClick={handleDoubleClick}
      >
        B
      </HeaderCompactButton>
    </>
  );
};

const HeaderCompactRightButton = () => {
  const tanksAudioRef = useRef(null);

  const playTanksSound = (e) => {
    e.preventDefault();
    if (tanksAudioRef.current) {
      tanksAudioRef.current.currentTime = 0;
      tanksAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playTanksSound(e);
    window.open('https://tanks.satoshiadvance.com', '_blank');
  };

  return (
    <>
      <audio ref={tanksAudioRef} src={`${AUDIO_BASE_URL}/TanksButton.mp3`} />
      <HeaderCompactButton
        onClick={playTanksSound}
        onDoubleClick={handleDoubleClick}
      >
        $
      </HeaderCompactButton>
    </>
  );
};

const HeaderCompactBottomLeftButton = () => {
  const flipAudioRef = useRef(null);

  const playFlipSound = (e) => {
    e.preventDefault();
    if (flipAudioRef.current) {
      flipAudioRef.current.currentTime = 0;
      flipAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playFlipSound(e);
    window.open('https://flip.satoshiadvance.com', '_blank');
  };

  return (
    <>
      <audio ref={flipAudioRef} src={`${AUDIO_BASE_URL}/FlipButton.mp3`} />
      <HeaderCompactButton
        onClick={playFlipSound}
        onDoubleClick={handleDoubleClick}
      >
        ©
      </HeaderCompactButton>
    </>
  );
};

const HeaderCompactPaymentButton = ({ onClick }) => {
  const payAudioRef = useRef(null);

  const playPaySound = (e) => {
    e.preventDefault();
    if (payAudioRef.current) {
      payAudioRef.current.currentTime = 0;
      payAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playPaySound(e);
    onClick();
  };

  return (
    <>
      <audio ref={payAudioRef} src={`${AUDIO_BASE_URL}/PayButton.mp3`} />
      <HeaderCompactButton
        onClick={playPaySound}
        onDoubleClick={handleDoubleClick}
      >
        D
      </HeaderCompactButton>
    </>
  );
};

// Buttons with specific content and links
const LeftButton = ({ compact, neonColor }) => {
  const wheelAudioRef = useRef(null);

  const playWheelSound = (e) => {
    e.preventDefault(); // Prevent single click from navigating
    if (wheelAudioRef.current) {
      wheelAudioRef.current.currentTime = 0;
      wheelAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playWheelSound(e);
    window.open('/bitwheel', '_blank');
  };

  return (
    <>
      <audio ref={wheelAudioRef} src={`${AUDIO_BASE_URL}/WheelButton.mp3`} />
      <Box
        onClick={playWheelSound}
        onDoubleClick={handleDoubleClick}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <RetroSquareButton compact={compact}>B</RetroSquareButton>
        {!compact && <ButtonLabel>Spin</ButtonLabel>}
        {!compact && neonColor && <NeonControllerIcon neonColor={neonColor} />}
      </Box>
    </>
  );
};

const RightButton = ({ compact, neonColor }) => {
  const tanksAudioRef = useRef(null);

  const playTanksSound = (e) => {
    e.preventDefault();
    if (tanksAudioRef.current) {
      tanksAudioRef.current.currentTime = 0;
      tanksAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playTanksSound(e);
    window.open('https://tanks.satoshiadvance.com', '_blank');
  };

  return (
    <>
      <audio ref={tanksAudioRef} src={`${AUDIO_BASE_URL}/TanksButton.mp3`} />
      <Box
        onClick={playTanksSound}
        onDoubleClick={handleDoubleClick}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <RetroSquareButton compact={compact}>$</RetroSquareButton>
        {!compact && <ButtonLabel>Shoot</ButtonLabel>}
        {!compact && neonColor && <NeonControllerIcon neonColor={neonColor} />}
      </Box>
    </>
  );
};

// Add this code below your existing LeftButton and RightButton components
const BottomLeftButton = ({ compact, neonColor }) => {
  const flipAudioRef = useRef(null);

  const playFlipSound = (e) => {
    e.preventDefault();
    if (flipAudioRef.current) {
      flipAudioRef.current.currentTime = 0;
      flipAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
  };

  const handleDoubleClick = (e) => {
    playFlipSound(e);
    window.open('https://flip.satoshiadvance.com', '_blank');
  };

  return (
    <>
      <audio ref={flipAudioRef} src={`${AUDIO_BASE_URL}/FlipButton.mp3`} />
      <Box
        onClick={playFlipSound}
        onDoubleClick={handleDoubleClick}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <RetroSquareButton compact={compact}>©</RetroSquareButton>
        {!compact && <ButtonLabel>Flip</ButtonLabel>}
        {!compact && neonColor && <NeonControllerIcon neonColor={neonColor} />}
      </Box>
    </>
  );
};

const RetroText = styled(motion(Typography))(({ theme }) => ({
  color: '#FFFFFF', // White lettering
  textShadow: `
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000
  `,
  fontWeight: 'bold',
  fontSize: '2.4rem',
  letterSpacing: '2px',
  textTransform: 'uppercase',
  fontFamily: "'Press Start 2P', cursive",
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.2rem',
  },
}));

const RetroIconButton = styled(motion(IconButton))(({ theme }) => ({
  color: '#FFFFFF',
  textShadow: `
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000
  `,
  fontSize: '4rem',
  marginRight: '20px',
  '& .MuiSvgIcon-root': {
    fontSize: '4rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '3.0rem',
    '& .MuiSvgIcon-root': {
      fontSize: '3.0rem',
    },
  },
}));

export const DividerBar = styled(motion('div'))(({ theme }) => ({
  width: '80%',
  height: '4px',
  backgroundColor: '#FFFFFF',
  margin: '20px auto 0',
  marginBottom: '30px',
  transformOrigin: 'center',
  boxShadow: `
    0 0 10px #FFFFFF,
    0 0 20px #00BFFF,
    0 0 30px #00BFFF,
    0 0 40px #00BFFF,
    0 0 70px #FFFFFF,
    0 0 80px #FFFFFF,
    0 0 100px #00BFFF,
    0 0 150px #00BFFF
  `,
  [theme.breakpoints.down('sm')]: {
    width: '95%',
  },
}));

export const MotionDivider = () => {
  return (
    <DividerBar
      initial={{ scaleX: 0 }}
      animate={{
        scaleX: 1,
        rotateX: 15,
      }}
      transition={{
        duration: 2,
        ease: "easeInOut",
      }}
    />
  );
};

const EmailInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    fontFamily: "'Press Start 2P', cursive",
    fontSize: '1rem',
    color: '#FFFFFF',
    backgroundColor: '#283593',
    borderRadius: '4px',
    width: '562.5px',
    height: '40px',
    boxSizing: 'border-box',
    padding: '10px 14px',
    border: '2px solid #FFFFFF',
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#3949ab',
      borderColor: '#FFFFFF',
    },
    '&.Mui-focused': {
      borderColor: '#FFFFFF',
    },
    '& fieldset': {
      border: 'none',
    },
  },
  '& .MuiInputBase-input': {
    color: '#FFFFFF',
    padding: '10px 0',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '95vw',
    '& .MuiOutlinedInput-root': {
      width: '100%',
    }
  }
}));

const SignUpButton = styled(Button)(({ theme }) => ({
  fontFamily: "'Press Start 2P', cursive",
  fontSize: '1rem',
  color: '#FFFFFF',
  backgroundColor: '#283593',
  border: '2px solid #FFFFFF',
  borderRadius: '4px',
  padding: '10px 20px',
  marginLeft: '0',
  textTransform: 'uppercase',
  height: '40px',
  '&:hover': {
    backgroundColor: '#1a237e',
    borderColor: '#FFFFFF',
  },
  [theme.breakpoints.down('sm')]: {
    width: '120px',
    fontSize: '0.8rem',
    padding: '8px 16px',
    margin: '0 auto',
  }
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  borderBottom: '1px solid #fff',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2000,
  backgroundColor: '#283593',
  paddingTop: '15px',
  paddingBottom: '10px',
  // On desktop, pull the site name and mansion icon inward to a tablet-width
  // column (~1024px) so they sit closer to the content, ticker edges, and
  // glow bar instead of hugging the far corners of wide monitors.
  paddingLeft: 'max(0.5in, calc((100% - 1024px) / 2))',
  paddingRight: 'max(20px, calc((100% - 1024px) / 2))',
  boxSizing: 'border-box', // Ensure padding is included in width calculation

  [theme.breakpoints.down('sm')]: {
    padding: '15px 0.25in 10px 0.25in'
  }
}));

// Mansion "Home" icon (same silhouette as the games' home buttons): solid
// white mansion with windows/door cut in the header background blue.
const MansionIcon = ({ size = 28 }) => (
  <svg
    viewBox="0 0 36 36"
    width={size}
    height={size}
    style={{ display: 'block', fill: '#FFFFFF' }}
    aria-hidden="true"
  >
    {/* Mansion silhouette: center peaked roof + two symmetrical wings */}
    <path d="M18,2 L24,8 L24,5 L26,5 L26,10 L28,12 L28,26 L8,26 L8,12 L10,10 L10,5 L12,5 L12,8 L18,2 Z M4,16 L8,12 L8,26 L4,26 Z M28,12 L32,16 L32,26 L28,26 Z" />
    {/* Windows - 2nd floor */}
    <rect fill="#283593" x="13" y="10" width="3" height="3" />
    <rect fill="#283593" x="20" y="10" width="3" height="3" />
    {/* Windows - 1st floor */}
    <rect fill="#283593" x="13" y="16" width="3" height="3" />
    <rect fill="#283593" x="20" y="16" width="3" height="3" />
    {/* Door */}
    <rect fill="#283593" x="16" y="20" width="4" height="6" />
    {/* Wing windows */}
    <rect fill="#283593" x="5" y="18" width="2" height="3" />
    <rect fill="#283593" x="29" y="18" width="2" height="3" />
    {/* Driveway/ground base */}
    <rect x="10" y="26" width="16" height="2" />
    {/* Columns/pillars at entrance */}
    <rect x="14" y="20" width="1" height="6" />
    <rect x="21" y="20" width="1" height="6" />
  </svg>
);

const HeaderCompactButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'compact'
})(({ theme }) => ({
  width: '20px',              // Much smaller than regular compact (was 60px mobile, 24px tablet)
  height: '20px',
  backgroundColor: '#1a237e',
  border: '1px solid #FFFFFF', // Thinner border
  color: '#FFFFFF',
  fontSize: '0.6rem',         // Smaller font
  fontFamily: "'Press Start 2P', cursive",
  textShadow: `
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000
  `,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: '#283593',
    transform: 'scale(1.1)',   // Subtle hover effect
  },
  position: 'relative',
  zIndex: 10,

  [theme.breakpoints.down('sm')]: {
    width: '18px',             // Even smaller on mobile
    height: '18px',
    fontSize: '0.5rem',
    border: '1px solid #FFFFFF',
  }
}));


const HeaderTitle = styled(Typography)({
  fontFamily: "'Roboto', sans-serif",
  fontSize: '22px',
  color: '#fff',
  marginBottom: '2px',
  display: 'block', // Ensure it's always displayed
  textAlign: 'left'
});

const HeaderLink = styled(Link)({
  fontFamily: "'Roboto', sans-serif",
  fontSize: '19px',
  color: '#fff',
  textDecoration: 'none',
  marginBottom: '2px',
  cursor: 'pointer',
  '&:hover': {
    color: '#ccc',
  },
});

const FooterBar = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center', // Center the content horizontally
  alignItems: 'center',
  gap: '1rem',              // Space between items
  backgroundColor: '#283593',
  padding: '10px 20px',
  zIndex: 1000,
}));

const AppLink = styled(Link)({
  fontFamily: "'Roboto', sans-serif",
  fontSize: '19px',
  color: '#fff',
  textDecoration: 'none',
  display: 'inline-flex',   // so we can place the icon after the text
  alignItems: 'center',     // vertically center text & icon
  cursor: 'pointer',
  '&:hover': {
    color: '#ccc',
  },
});





const FooterLink = styled(Link)({
  fontFamily: "'Roboto', sans-serif",
  fontSize: '19px',
  color: '#fff',
  textDecoration: 'none',
  '&:hover': {
    color: '#ccc',
  },
});

const InfoBanner = styled(Box)(({ theme }) => ({
  color: '#FFFFFF',
  padding: '8px 0',
  margin: '10px 0',
  textAlign: 'center',
  fontFamily: "'Press Start 2P', cursive",
  fontStyle: 'italic',
}));

const InfoLineMain = styled(Typography)(({ theme }) => ({
  fontFamily: "'Press Start 2P', cursive",
  fontSize: '1.4rem',
  fontWeight: 'bold',
  color: '#FFFFFF',
  fontStyle: 'italic',
  textShadow: '0 0 6px #00BFFF',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
}));

const InfoLineSub = styled(InfoLineMain)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 600,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem',
  },
}));

const GAME_MODE_NEON_COLORS = [
  { color: '#cc66ff', glow: '#a020f0' },
  { color: '#ff3366', glow: '#ff0033' },
  { color: '#ffdd33', glow: '#806600' },
  { color: '#ff8c00', glow: '#ff5500' },
];

const GameModeToggleButton = styled(IconButton)(({ theme }) => ({
  padding: '6px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}));

const GameModeLabel = styled(Typography)(({ theme }) => ({
  fontFamily: "'Press Start 2P', cursive",
  color: '#FFFFFF',
  fontSize: '0.65rem',
  letterSpacing: '1px',
  marginTop: '2px',
  textShadow: `
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000
  `,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.55rem',
  },
}));

const GodModeToggle = ({ godMode, onToggle }) => (
  <Tooltip
    arrow
    title={
      <Typography variant="body2">
        {godMode ? 'God Mode: ON — tap to turn off' : 'God Mode: OFF — tap to activate'}
      </Typography>
    }
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        marginTop: '8px',
      }}
      onClick={onToggle}
    >
      <GameModeToggleButton aria-label="Toggle God Mode">
        <SportsEsportsIcon
          sx={{
            fontSize: { xs: '2rem', md: '2.4rem' },
            color: godMode ? '#FFFFFF' : '#3a3a3a',
            filter: godMode
              ? 'drop-shadow(0 0 4px rgba(255,255,255,0.9)) drop-shadow(0 0 8px rgba(255,255,255,0.6))'
              : 'none',
            transition: 'color 0.15s linear, filter 0.15s linear',
          }}
        />
      </GameModeToggleButton>
      <GameModeLabel>{godMode ? 'GOD MODE: ON' : 'GOD MODE'}</GameModeLabel>
    </Box>
  </Tooltip>
);

const GameModeToggle = ({ gameMode, onToggle }) => (
  <Tooltip
    arrow
    title={
      <Typography variant="body2">
        {gameMode ? 'Game Mode: ON — exit to financial-only view' : 'Game Mode: OFF — tap to load mini games'}
      </Typography>
    }
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={onToggle}
    >
      <GameModeToggleButton aria-label="Toggle Game Mode">
        {gameMode ? (
          <SportsEsportsIcon
            sx={{
              fontSize: { xs: '2rem', md: '2.4rem' },
              color: '#39ff14',
              filter: 'drop-shadow(0 0 4px #00cc00) drop-shadow(0 0 8px #00cc00)',
            }}
          />
        ) : (
          <SportsEsportsOutlinedIcon
            sx={{
              fontSize: { xs: '2rem', md: '2.4rem' },
              color: '#FFFFFF',
              filter: 'drop-shadow(0 0 2px rgba(255,255,255,0.6))',
            }}
          />
        )}
      </GameModeToggleButton>
      <GameModeLabel>{gameMode ? 'GAME MODE: ON' : 'GAME MODE'}</GameModeLabel>
    </Box>
  </Tooltip>
);

const PriceDisplay = () => {
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [signUpContext, setSignUpContext] = useState('');
  const [price, setPrice] = useState(null);
  const [showDashboard, setShowDashboard] = useState(false);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [playlist] = useState([
    `${AUDIO_BASE_URL}/retrodisco.mp3`,
    `${AUDIO_BASE_URL}/retrolightning.mp3`,
    `${AUDIO_BASE_URL}/retrotrance.mp3`,
    `${AUDIO_BASE_URL}/retrogame8.mp3`,
    `${AUDIO_BASE_URL}/UpbeatRetroIntro.mp3`,
    `${AUDIO_BASE_URL}/DogTunes7.mp3`,
    `${AUDIO_BASE_URL}/DogTunes1.mp3`,
    `${AUDIO_BASE_URL}/DogTunes2.mp3`,
    `${AUDIO_BASE_URL}/DogTunes3.mp3`,
    `${AUDIO_BASE_URL}/DogTunes4.mp3`,
    `${AUDIO_BASE_URL}/DogTunes5.mp3`,
    `${AUDIO_BASE_URL}/DogTunes6.mp3`,
    `${AUDIO_BASE_URL}/DogTunes8.mp3`,
    `${AUDIO_BASE_URL}/DogTunes9.mp3`,
    `${AUDIO_BASE_URL}/DogTunes10.mp3`,
    `${AUDIO_BASE_URL}/DogTunes11.mp3`,
    `${AUDIO_BASE_URL}/DogTunes12.mp3`,
    `${AUDIO_BASE_URL}/DogTunes13.mp3`,
    `${AUDIO_BASE_URL}/DogTunes14.mp3`,
    `${AUDIO_BASE_URL}/DogTunes15.mp3`,
  ]);
  const audioRef = useRef(null);
  // Consecutive failed-to-load track counter for the error→skip handler
  const failedTracksRef = useRef(0);
  const aboutAudioRef = useRef(null);
  const nextButtonAudioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Volume state & toggle
  const [volume, setVolume] = useState(1);
  const toggleVolume = () => {
    if (isIOS) {
      // Just toggle the visual state
      setVolume(volume === 1 ? 0.33 : 1);

      // Show a one-time notification to iOS users
      if (!localStorage.getItem('volume-notice-shown')) {
        alert("On iOS devices, please use the hardware volume buttons to adjust sound. This app will still show volume icons for visual feedback.");
        localStorage.setItem('volume-notice-shown', 'true');
      }
    } else {
      // Normal volume toggle for non-iOS
      if (audioRef.current) {
        audioRef.current.volume = volume === 1 ? 0.33 : 1;
      }
      setVolume(volume === 1 ? 0.33 : 1);
    }
  };

  // For TTS (speak once) & fade logic

  const [hasSpoken, setHasSpoken] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showCompactButtons, setShowCompactButtons] = useState(false);
  const buttonGridRef = useRef(null);
  const [compactMenuAnchor, setCompactMenuAnchor] = useState(null);
  const [gameMode, setGameMode] = useState(false);

  // "Find Sprite" handoff from the dashboard's custom breed generator:
  // turn on game mode, close the dashboard, and scroll to the dog game
  // (the card itself travels via sessionStorage / the loadCustomDogCard event)
  useEffect(() => {
    const openDogGame = () => {
      setGameMode(true);
      setShowDashboard(false);
      setTimeout(() => {
        const element = document.getElementById('dogsprite');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 400);
    };
    window.addEventListener('openDogGame', openDogGame);
    return () => window.removeEventListener('openDogGame', openDogGame);
  }, []);
  const [godMode, setGodMode] = useState(false);
  const gameModeAudioRef = useRef(null);
  const godModeAudioCtxRef = useRef(null);

  const playGodModeBeep = () => {
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;
      if (!godModeAudioCtxRef.current) {
        godModeAudioCtxRef.current = new AudioCtx();
      }
      const ctx = godModeAudioCtxRef.current;
      if (ctx.state === 'suspended') ctx.resume();
      const playBeep = (freq, startOffset) => {
        const start = ctx.currentTime + startOffset;
        const dur = 0.09;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'square';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, start);
        gain.gain.linearRampToValueAtTime(0.18, start + 0.005);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
        osc.connect(gain).connect(ctx.destination);
        osc.start(start);
        osc.stop(start + dur);
      };
      playBeep(880, 0);     // A5
      playBeep(1320, 0.1);  // E6 — coin-drop two-tone
    } catch (err) {
      // Web Audio unavailable — silent fallback
    }
  };

  const toggleGodMode = () => {
    playGodModeBeep();
    setGodMode((prev) => !prev);
  };

  const logoRef = useRef(null);
  const lastLogoAngleRef = useRef(null);
  const lastLogoMoveTimeRef = useRef(null);
  const logoAngularVelocityRef = useRef(0); // degrees per ms
  const logoMomentumRafRef = useRef(null);
  const [logoRotation, setLogoRotation] = useState(0);

  // Click-and-drag horizontal positioning (desktop). The logo can be dragged
  // left/right; the offset persists for the page lifetime. Rotation handlers
  // skip while a drag is in progress so the two interactions don't fight.
  const [logoTranslateX, setLogoTranslateX] = useState(0);
  const isDraggingLogoRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartTranslateXRef = useRef(0);

  const cancelLogoMomentum = () => {
    if (logoMomentumRafRef.current) {
      cancelAnimationFrame(logoMomentumRafRef.current);
      logoMomentumRafRef.current = null;
    }
  };

  const startLogoMomentumDecay = () => {
    cancelLogoMomentum();
    let lastFrameTime = performance.now();
    // friction = 0.97 per 60Hz frame — light decay so fast spins last ~3s, slow spins fade in <1s
    const tick = (now) => {
      const dt = Math.min(now - lastFrameTime, 50); // cap dt to avoid jumps after tab-switch
      lastFrameTime = now;
      setLogoRotation((prev) => prev + logoAngularVelocityRef.current * dt);
      logoAngularVelocityRef.current *= Math.pow(0.97, dt / 16.67);
      if (Math.abs(logoAngularVelocityRef.current) < 0.0015) {
        logoAngularVelocityRef.current = 0;
        logoMomentumRafRef.current = null;
        return;
      }
      logoMomentumRafRef.current = requestAnimationFrame(tick);
    };
    logoMomentumRafRef.current = requestAnimationFrame(tick);
  };

  const updateLogoFromPointer = (clientX, clientY) => {
    if (!logoRef.current) return;
    cancelLogoMomentum(); // user grabs control again
    const rect = logoRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const angleDeg = Math.atan2(clientY - centerY, clientX - centerX) * (180 / Math.PI);
    const now = performance.now();

    if (lastLogoAngleRef.current !== null) {
      let delta = angleDeg - lastLogoAngleRef.current;
      if (delta > 180) delta -= 360;
      if (delta < -180) delta += 360;
      setLogoRotation((prev) => prev + delta);

      const dt = now - (lastLogoMoveTimeRef.current ?? now);
      if (dt > 0 && dt < 100) {
        logoAngularVelocityRef.current = delta / dt;
      }
    }
    lastLogoAngleRef.current = angleDeg;
    lastLogoMoveTimeRef.current = now;
  };

  const handleLogoMouseMove = (e) => {
    if (isDraggingLogoRef.current) return; // drag mode takes over
    updateLogoFromPointer(e.clientX, e.clientY);
  };
  const handleLogoTouchMove = (e) => {
    if (e.touches[0]) updateLogoFromPointer(e.touches[0].clientX, e.touches[0].clientY);
  };

  const handleLogoMouseDown = (e) => {
    // Primary button only — let middle/right clicks fall through to the browser.
    if (e.button !== 0) return;
    e.preventDefault();
    cancelLogoMomentum();
    isDraggingLogoRef.current = true;
    dragStartXRef.current = e.clientX;
    dragStartTranslateXRef.current = logoTranslateX;
    // Stop angle tracking so the next hover doesn't snap-rotate.
    lastLogoAngleRef.current = null;
    lastLogoMoveTimeRef.current = null;
    logoAngularVelocityRef.current = 0;
    document.body.style.cursor = 'grabbing';
    document.body.style.userSelect = 'none';

    const handleWindowMove = (ev) => {
      if (!isDraggingLogoRef.current) return;
      const delta = ev.clientX - dragStartXRef.current;
      setLogoTranslateX(dragStartTranslateXRef.current + delta);
    };
    const handleWindowUp = () => {
      isDraggingLogoRef.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      window.removeEventListener('mousemove', handleWindowMove);
      window.removeEventListener('mouseup', handleWindowUp);
    };
    window.addEventListener('mousemove', handleWindowMove);
    window.addEventListener('mouseup', handleWindowUp);
  };

  const releaseLogo = () => {
    const now = performance.now();
    const timeSinceLastMove = lastLogoMoveTimeRef.current ? now - lastLogoMoveTimeRef.current : Infinity;
    lastLogoAngleRef.current = null;
    lastLogoMoveTimeRef.current = null;
    // Only spin on with momentum if the pointer was actually moving when it left.
    if (timeSinceLastMove < 150 && Math.abs(logoAngularVelocityRef.current) > 0.001) {
      startLogoMomentumDecay();
    } else {
      logoAngularVelocityRef.current = 0;
    }
  };

  const handleLogoMouseLeave = () => releaseLogo();
  const handleLogoTouchEnd = () => releaseLogo();

  useEffect(() => () => cancelLogoMomentum(), []);

  const toggleGameMode = () => {
    if (gameModeAudioRef.current) {
      gameModeAudioRef.current.currentTime = 0;
      gameModeAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }
    setGameMode((prev) => !prev);
  };

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const scrollToHash = () => {
      const rawHash = window.location.hash ? window.location.hash.substring(1) : '';
      const normalizedHash = rawHash.toLowerCase();
      if (!rawHash) {
        return;
      }

      const element = document.getElementById(rawHash) || document.getElementById(normalizedHash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const handleLoad = () => window.requestAnimationFrame(scrollToHash);

    window.addEventListener('hashchange', scrollToHash);
    window.addEventListener('load', handleLoad);

    let timeoutId;
    if (window.location.hash) {
      timeoutId = window.setTimeout(scrollToHash, 300);
    }

    return () => {
      window.removeEventListener('hashchange', scrollToHash);
      window.removeEventListener('load', handleLoad);
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  // iOS detection
  useEffect(() => {
    // Check if the device is running iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Pre-load audio for iOS
    if (iOS && audioRef.current) {
      // Set initial source to enable later playback
      audioRef.current.src = playlist[currentTrackIndex];
      // Add dummy event listener to prepare audio context
      document.addEventListener('touchstart', () => { }, { passive: true });
    }
  }, []);

  // Improved fade-in music function with iOS support
  const fadeInMusic = () => {
    if (!audioRef.current) return;

    setIsFading(true);

    // Start at volume 0
    audioRef.current.volume = 0;

    let stepCount = isIOS ? 10 : 30; // Fewer steps for iOS for quicker fade
    let currentStep = 0;
    const fadeInterval = setInterval(() => {
      currentStep++;

      // Calculate the new volume, capped at max volume
      const calculatedVolume = (currentStep / stepCount) * 0.75;
      const newVolume = Math.min(calculatedVolume, volume);

      // Apply the new volume
      if (audioRef.current) {
        audioRef.current.volume = newVolume;
      }

      if (currentStep >= stepCount) {
        clearInterval(fadeInterval);
        setIsFading(false);
      }
    }, isIOS ? 500 : 1000); // Faster intervals for iOS (0.5s vs 1s)

    return fadeInterval;
  };

  const readTickerAloud = () => {
    console.log("Read ticker aloud requested, isIOS:", isIOS);

    if (!('speechSynthesis' in window)) {
      console.log("Speech synthesis not supported in this browser");
      return;
    }

    // Force cancel any existing speech
    window.speechSynthesis.cancel();

    if (isIOS) {
      // Simple, direct approach - no alerts
      try {
        // Create a short, concise message
        const iosSummary = "Hello and Welcome to Satoshi Advance. Home for Crypto Loans, News, Shopping, Games & More. Thanks for visiting"

        // Create utterance with iOS-friendly settings
        const utterance = new SpeechSynthesisUtterance(iosSummary);
        utterance.rate = 0.9;
        utterance.pitch = 1.0;
        utterance.volume = 1.0;

        // Speak immediately without any alerts or delays
        window.speechSynthesis.speak(utterance);

        // Log for debugging
        console.log("iOS speech initiated");
      } catch (err) {
        console.error("iOS speech error:", err);
      }
    } else {
      // Non-iOS devices continue with normal behavior
      try {
        const utterance = new SpeechSynthesisUtterance(tickerString);
        utterance.rate = 0.9;
        utterance.volume = 1.0;
        window.speechSynthesis.speak(utterance);
      } catch (err) {
        console.error("Speech error:", err);
      }
    }
  };

  // Modified toggleMusic to handle iOS differently
  const toggleMusic = () => {
    console.log("Toggle music called, isIOS:", isIOS);

    if (!audioRef.current) return;

    if (isPlaying) {
      // Pause logic remains the same
      audioRef.current.pause();
      setIsPlaying(false);
      return;
    }

    // Special handling for iOS
    if (isIOS) {
      console.log("Using iOS-specific playback approach");
      // On iOS, trigger speech immediately with user action
      if (!hasSpoken) {
        console.log("Triggering speech directly from user action");
        readTickerAloud();
        setHasSpoken(true);
      }

      // Then attempt audio playback
      audioRef.current.src = playlist[currentTrackIndex];
      audioRef.current.load();
      audioRef.current.play()
        .then(() => {
          console.log("iOS audio playback started successfully");
          setIsPlaying(true);
          audioRef.current.volume = 0.1; // Start quiet on iOS

          // Simple fade-in for iOS
          setTimeout(() => {
            if (audioRef.current) audioRef.current.volume = 0.3;
          }, 2000);
        })
        .catch(error => console.log('iOS audio playback error:', error));
    } else {
      // Non-iOS logic remains largely the same
      audioRef.current.src = playlist[currentTrackIndex];
      audioRef.current.load();
      audioRef.current.play()
        .then(() => {
          setIsPlaying(true);
          fadeInMusic();

          if (!hasSpoken) {
            setTimeout(() => {
              readTickerAloud();
              setHasSpoken(true);
            }, 500);
          }
        })
        .catch((error) => {
          console.log('Error playing audio:', error);
        });
    }
  };

  const skipTrack = () => {
    const nextIndex = currentTrackIndex < playlist.length - 1 ? currentTrackIndex + 1 : 0;
    setCurrentTrackIndex(nextIndex);
  };

  // Auto-play next track when current track ends
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleTrackEnd = () => {
      if (isPlaying) {
        // Move to next track
        const nextIndex = currentTrackIndex < playlist.length - 1 ? currentTrackIndex + 1 : 0;
        setCurrentTrackIndex(nextIndex);
      }
    };

    audio.addEventListener('ended', handleTrackEnd);

    return () => {
      audio.removeEventListener('ended', handleTrackEnd);
    };
  }, [isPlaying, currentTrackIndex, playlist.length]);

  // Skip past tracks that fail to load (404, decode error) so one bad file
  // doesn't silently kill the music. Stops after one full failed cycle.
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleError = () => {
      failedTracksRef.current += 1;
      if (failedTracksRef.current >= playlist.length) return;
      setCurrentTrackIndex((prev) => (prev < playlist.length - 1 ? prev + 1 : 0));
    };
    const handleCanPlay = () => {
      failedTracksRef.current = 0;
    };

    audio.addEventListener('error', handleError);
    audio.addEventListener('canplay', handleCanPlay);

    return () => {
      audio.removeEventListener('error', handleError);
      audio.removeEventListener('canplay', handleCanPlay);
    };
  }, [playlist.length]);

  // Updated track ending handler
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = playlist[currentTrackIndex];
      if (isPlaying) {
        audioRef.current.load();
        audioRef.current.play()
          .catch(error => console.log('Error playing audio:', error));
      }
    }
  }, [currentTrackIndex, playlist, isPlaying]);

  // Keep audioRef in sync with volume toggles
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  useEffect(() => {
    const fetchBTCPrice = async () => {
      try {
        // Determine the base URL based on environment
        const baseURL = window.location.hostname === 'localhost'
          ? 'http://localhost:5000'  // Local development
          : 'https://satoshi-homepage-59650ad0a3ce.herokuapp.com'; // Production Heroku URL

        console.log('Fetching BTC price from:', baseURL);

        const response = await axios.get(`${baseURL}/api/btc-price`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          withCredentials: true
        });

        if (response.data?.success && response.data?.price) {
          const formattedPrice = parseFloat(response.data.price).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
          });
          setPrice(formattedPrice);
          console.log('Successfully set BTC price:', formattedPrice);
        } else {
          throw new Error('Invalid price data received');
        }
      } catch (error) {
        console.error('Error fetching BTC price:', error.message);
        setPrice('Price Unavailable');

        // Detailed error logging
        if (error.response) {
          console.error('Error response:', {
            status: error.response.status,
            data: error.response.data
          });
        }
      }
    };

    fetchBTCPrice();
    const interval = setInterval(fetchBTCPrice, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Check if running on iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    console.log("iOS detection:", iOS);
    setIsIOS(iOS);
  }, []);

  useEffect(() => {
    // If there's a hash, scroll to it after a short delay
    if (window.location.hash) {
      const rawAnchorId = window.location.hash.substring(1);
      const normalizedAnchorId = rawAnchorId.toLowerCase();
      setTimeout(() => {
        const anchorElement =
          document.getElementById(rawAnchorId) ||
          document.getElementById(normalizedAnchorId);
        if (anchorElement) {
          anchorElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 800);
    }
  }, []);

  // Autoplay attempt: pick a random track
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * playlist.length);
    setCurrentTrackIndex(randomIndex);

    // On iOS, don't attempt autoplay as it will fail
    if (audioRef.current && !isIOS) {
      audioRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch((error) => {
        console.log('Autoplay failed:', error);
      });
    }
  }, []);

  useEffect(() => {
    const shouldShowWelcome = localStorage.getItem('showWelcomeNotification');
    if (shouldShowWelcome === 'true') {
      setShowWelcome(true);
      localStorage.removeItem('showWelcomeNotification');

      const audio = new Audio(`${AUDIO_BASE_URL}/retroshot.wav`);
      audio.play().catch(error => console.log('Error playing sound:', error));
    }
  }, []);

  // Show compact action buttons when scrolling past the button grid
  useEffect(() => {
    const handleScroll = () => {
      if (buttonGridRef.current) {
        const rect = buttonGridRef.current.getBoundingClientRect();
        setShowCompactButtons(rect.bottom <= 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nextButtonAudioRef.current) {
      nextButtonAudioRef.current.currentTime = 0;
      nextButtonAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
    }

    if (formStep === 1) {
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        setEmailValid(false);
        return;
      }
      setEmailValid(true);
      setFormStep(2);
    } else {
      try {
        await axios.post('/api/signup', formData);
        alert('Thank you for signing up!');
        setFormStep(1);
        setFormData({
          email: '',
          loanAmount: '',
          useOfFunds: '',
          country: ''
        });
      } catch (error) {
        console.error('Error signing up:', error);
        alert('Failed to sign up. Please try again.');
      }
    }
  };

  const openPaymentPopup = () => {
    setIsPopupOpen(true);
  };

  const closePaymentPopup = () => {
    setIsPopupOpen(false);
  };

  const scrollToDogSprite = (e) => {
    e.preventDefault();
    const element = document.getElementById('dogsprite') || document.getElementById('dogSprite');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [emailValid, setEmailValid] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // For payment popup

  const [formStep, setFormStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    loanAmount: '',
    useOfFunds: '',
    country: ''
  });

  const [showWelcome, setShowWelcome] = useState(false);
  const { userEmail, isAuthenticated, logout } = useAuth();
  const userData = isAuthenticated ? { email: userEmail } : null;

  const [homeMenuAnchor, setHomeMenuAnchor] = useState(null);
  const [loginTab, setLoginTab] = useState('login');

  const handleCompactMenuOpen = (event) => {
    setCompactMenuAnchor(event.currentTarget);
  };

  const handleCompactMenuClose = () => {
    setCompactMenuAnchor(null);
  };

  const handleHomeMenuOpen = (event) => {
    setHomeMenuAnchor(event.currentTarget);
  };

  const handleHomeMenuClose = () => {
    setHomeMenuAnchor(null);
  };

  // Navigation helpers for Home menu
  const goHome = () => {
    handleHomeMenuClose();
    window.location.href = '/';
  };

  const goBlogs = () => {
    handleHomeMenuClose();
    window.location.href = '/info-center';
  };

  const goShop = () => {
    handleHomeMenuClose();

    // Check if user is authenticated
    if (isAuthenticated) {
      window.location.href = '/shop';
    } else {
      // Prompt user to login/signup
      setSignUpContext('shop');
      setIsSignUpOpen(true);
    }
  };

  const goSubscribe = () => {
    handleHomeMenuClose();
    openPaymentPopup();
  };

  const goApply = () => {
    handleHomeMenuClose();
    const el = document.getElementById('applySection');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLogout = () => {
    logout(); // This will handle clearing localStorage/sessionStorage
    handleHomeMenuClose();

    const logoutSound = new Audio(`${AUDIO_BASE_URL}/retroshot.wav`);
    logoutSound.play().catch(error => console.log('Error playing sound:', error));
  };

  return (
    <Box
      sx={{
        textAlign: 'center',
        backgroundColor: '#283593',
        padding: '45px 20px 50px 20px',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflowX: 'hidden',
        maxWidth: '100vw',
        paddingBottom: '100px',
      }}
    >
      <HeaderContainer>
        {/* Left column - Title */}
        <HeaderTitle>Satoshi Advance</HeaderTitle>

        {/* Right side icons */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {/* Show compact + button only when scrolled past game cubes (and Game Mode is on) */}
          {showCompactButtons && gameMode && (
            <>
              <div
                onClick={handleCompactMenuOpen}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                  fontFamily: "'Press Start 2P', cursive",
                  userSelect: 'none',
                  transition: 'opacity 0.2s ease',
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                +
              </div>
              <Menu
                anchorEl={compactMenuAnchor}
                open={Boolean(compactMenuAnchor)}
                onClose={handleCompactMenuClose}
                PaperProps={{
                  sx: {
                    backgroundColor: '#283593',
                    border: '1px solid #FFFFFF',
                    '& .MuiMenuItem-root': {
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: '19px',
                      color: '#FFFFFF'
                    }
                  }
                }}
              >
                <MenuItem onClick={handleCompactMenuClose}><LeftButton compact /></MenuItem>
                <MenuItem onClick={handleCompactMenuClose}><RightButton compact /></MenuItem>
                <MenuItem onClick={handleCompactMenuClose}><BottomLeftButton compact /></MenuItem>
                <MenuItem onClick={() => { handleCompactMenuClose(); openPaymentPopup(); }}><PaymentButton compact /></MenuItem>
              </Menu>
            </>
          )}

          
          {/* Always show home icon for all users */}
          <IconButton 
            onClick={handleHomeMenuOpen}
            sx={{ 
              color: '#FFFFFF',
              padding: '8px',
              '&:hover': {
                backgroundColor: 'transparent'
              }
            }}
          >
            <MansionIcon />
          </IconButton>

          {/* Home menu with different options based on authentication */}
          <Menu
            anchorEl={homeMenuAnchor}
            open={Boolean(homeMenuAnchor)}
            onClose={handleHomeMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                backgroundColor: '#283593',
                border: '1px solid #FFFFFF',
                zIndex: 100003, // Higher than everything else
                marginTop: '8px', // Add some space from the header
                '& .MuiMenuItem-root': {
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: '19px',
                  color: '#FFFFFF',
                  padding: '12px 20px', // Better spacing for menu items
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                  }
                }
              }
            }}
            MenuListProps={{
              sx: {
                zIndex: 100003, // Ensure menu items are also above other elements
                padding: '4px 0' // Better padding around menu items
              }
            }}
          >
            {userData ? (
              // Authenticated user menu
              <>
                <MenuItem onClick={() => { handleHomeMenuClose(); setShowDashboard(true); }}>Account</MenuItem>
                <MenuItem onClick={goApply}>Apply</MenuItem>
                <MenuItem onClick={goShop}>Shop</MenuItem>
                <MenuItem onClick={goSubscribe}>Subscribe</MenuItem>
                <MenuItem onClick={goBlogs}>Blog</MenuItem>
                <MenuItem onClick={() => { handleHomeMenuClose(); handleLogout(); }}>Logout</MenuItem>
              </>
            ) : (
              // Non-authenticated user menu
              <>
                <MenuItem onClick={goHome}>Home</MenuItem>
                <MenuItem onClick={goApply}>Apply</MenuItem>
                <MenuItem onClick={goShop}>Shop</MenuItem>
                <MenuItem onClick={goSubscribe}>Subscribe</MenuItem>
                <MenuItem onClick={goBlogs}>Blog</MenuItem>
                <MenuItem onClick={() => { handleHomeMenuClose(); setIsSignUpOpen(true); setLoginTab('signup'); }}>Sign Up / Login</MenuItem>
              </>
            )}
          </Menu>
        </Box>

      </HeaderContainer>


      {/* Extra clearance below the fixed header so the ticker text isn't
          clipped by the header's white dividing line on any screen size */}
      <Box sx={{ paddingTop: { xs: '10px', md: '20px' } }}>
        <TickerTapeComponent content={tickerContent} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          margin: '20px auto 10px',
          position: 'relative',
        }}
      >
        {godMode && (
          <Box
            component="img"
            src="https://media.satoshiadvance.com/images/GodCircleOne.png"
            alt=""
            aria-hidden="true"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 'auto',
              maxWidth: { xs: '85%', sm: '70%', md: '55%', lg: '45%' },
              maxHeight: { xs: '180px', md: '300px' },
              objectFit: 'contain',
              pointerEvents: 'none',
              zIndex: 0,
              userSelect: 'none',
            }}
          />
        )}
        <Box
          component="img"
          ref={logoRef}
          draggable={false}
          onMouseDown={handleLogoMouseDown}
          onMouseMove={handleLogoMouseMove}
          onMouseLeave={handleLogoMouseLeave}
          onTouchMove={handleLogoTouchMove}
          onTouchEnd={handleLogoTouchEnd}
          onTouchCancel={handleLogoTouchEnd}
          src="https://media.satoshiadvance.com/images/spinner-top-3.png"
          alt="Satoshi Advance"
          sx={{
            width: 'auto',
            maxWidth: { xs: '85%', sm: '70%', md: '55%', lg: '45%' },
            maxHeight: { xs: '180px', md: '300px' },
            objectFit: 'contain',
            cursor: 'grab',
            '&:active': { cursor: 'grabbing' },
            transform: `translateX(${logoTranslateX}px) rotate(${logoRotation}deg)`,
            transition: 'transform 0.05s linear',
            willChange: 'transform',
            touchAction: 'none', // let swipe rotate the logo without scrolling the page
            position: 'relative',
            zIndex: 1,
          }}
        />
      </Box>

      <HeaderTitleMobile>Satoshi Advance</HeaderTitleMobile>


      {showWelcome && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          onClose={() => setShowWelcome(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Box
            sx={{
              backgroundColor: '#1a237e',
              color: '#FFFFFF',
              padding: '16px',
              borderRadius: '4px',
              border: '2px solid #FFFFFF',
              fontFamily: "'Press Start 2P', cursive",
              fontSize: '0.8rem',
              boxShadow: `
                0 0 10px #FFFFFF,
                0 0 20px #00BFFF,
                0 0 30px #00BFFF
              `,
            }}
          >
            Account setup complete! Welcome to Satoshi Advance
          </Box>
        </Snackbar>
      )}

      <InfoBanner>
        <InfoLineMain>
          Crypto Financing made easy - borrow, invest, earn, use n' learn
        </InfoLineMain>
      </InfoBanner>

      <Box>
        {/* Mobile Layout (XS) */}
        <Box
          sx={{
            // Show only on extra-small screens up to the md breakpoint
            display: { xs: 'flex', md: 'none' },
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            marginTop: '40px',
          }}
        >
          {/* Row of 3 icons side by side, centered */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* Play/Pause */}
            <RetroIconButton onClick={toggleMusic}>
              {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
            </RetroIconButton>

            {/* Skip */}
            <RetroIconButton onClick={skipTrack}>
              <SkipNextIcon />
            </RetroIconButton>

            {/* Volume */}
            <RetroIconButton onClick={toggleVolume}>
              {volume === 1 ? (
                <VolumeUpIcon sx={{ fontSize: '3rem', color: '#FFFFFF' }} />
              ) : (
                <VolumeDownIcon sx={{ fontSize: '3rem', color: '#FFFFFF' }} />
              )}
            </RetroIconButton>
          </Box>

          {/* BTC Price below the icons */}
          <Box sx={{ marginTop: 2 }}>
            <RetroText>{price || '$0.00'}</RetroText>
          </Box>

          {/* Game Mode toggle below music + price */}
          <Box sx={{ marginTop: 1 }}>
            <GameModeToggle gameMode={gameMode} onToggle={toggleGameMode} />
          </Box>
        </Box>

        {/* Desktop Layout (MD+) */}
        <Box
          sx={{
            // Show only on screens >= md
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '80px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
            }}
          >
            {/* Left: Play/Pause */}
            <RetroIconButton onClick={toggleMusic}>
              {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
            </RetroIconButton>

            {/* Center: BTC Price */}
            <RetroText>{price || '$0.00'}</RetroText>

            {/* Right: Skip + Volume */}
            <RetroIconButton onClick={skipTrack}>
              <SkipNextIcon />
            </RetroIconButton>
            <RetroIconButton onClick={toggleVolume}>
              {volume === 1 ? (
                <VolumeUpIcon sx={{ fontSize: '3rem', color: '#FFFFFF' }} />
              ) : (
                <VolumeDownIcon sx={{ fontSize: '3rem', color: '#FFFFFF' }} />
              )}
            </RetroIconButton>
          </Box>

          {/* Game Mode toggle below music row */}
          <Box sx={{ marginTop: 1 }}>
            <GameModeToggle gameMode={gameMode} onToggle={toggleGameMode} />
          </Box>
        </Box>
      </Box>

      {gameMode && (
        <ButtonGrid ref={buttonGridRef}>
          <LeftButton neonColor={GAME_MODE_NEON_COLORS[0]} />
          <RightButton neonColor={GAME_MODE_NEON_COLORS[1]} />
          <BottomLeftButton neonColor={GAME_MODE_NEON_COLORS[2]} />
          <PaymentButton onClick={openPaymentPopup} neonColor={GAME_MODE_NEON_COLORS[3]} />
        </ButtonGrid>
      )}

      {gameMode && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1 }}>
          <GodModeToggle godMode={godMode} onToggle={toggleGodMode} />
        </Box>
      )}

      <InfoBanner>
        <InfoLineSub>
          Sign up today to borrow or lend straight away!
        </InfoLineSub>
      </InfoBanner>

      <MotionDivider />

      {/* Same purple glow treatment as the other interactive boxes
          (Buy Crypto Online, purchase finder, converter) */}
      <Box
        component={motion.div}
        initial={{ opacity: 0 }}
        whileInView={{
          opacity: 1,
          boxShadow: '0 0 20px #9932CC, 0 0 30px #9932CC, 0 0 40px #9932CC'
        }}
        viewport={{ once: true, amount: 0.15 }}
        whileHover={{
          boxShadow: '0 0 40px #BA55D3, 0 0 60px #BA55D3, 0 0 80px #BA55D3'
        }}
        transition={{ duration: 1.5, ease: 'easeInOut' }}
        sx={{
          width: '100%',
          padding: '20px 10px 22px',
          boxSizing: 'border-box',
          backgroundColor: '#1a237e',
          marginY: '40px',
          borderRadius: '10px'
        }}
      >
        <Box id="applySection">
          <LenderBorrowerApply />
        </Box>
      </Box>

      <audio ref={audioRef} src={playlist[currentTrackIndex]} preload="none" />
      <audio ref={nextButtonAudioRef} src={`${AUDIO_BASE_URL}/retroshot.wav`} />
      <audio ref={gameModeAudioRef} src={`${AUDIO_BASE_URL}/retroshot.wav`} />

      <AAdsBanner />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: {
            xs: '0',
            sm: '0',
            md: '-0.17in'
          },
          width: '100%',
          '& > *': {
            width: { xs: '95%', md: '100vw' },
            maxWidth: '2900px',
          },
        }}
      >
        <TopCryptoLoans />
      </Box>

      <TickerTapeComponent content={tickerContent} />

      <UsdVsBtcComparison godMode={godMode} />

      <AAdsBanner />

      <NewsAndBlogs />

      <BuyCryptoOnline godMode={godMode} />
      <TickerTapeComponent content={tickerContent} />

      <AAdsBanner />

      <PopularLinks />

      <UsdToBtcConverter
        godMode={godMode}
        tickerComponent={<TickerTapeComponent content={tickerContent} />}
      />
      <EducationLinks />

      <CryptoPurchaseFinder godMode={godMode} />

      {gameMode && <PlayCoinGames />}

      {isPopupOpen && <PaymentPopup onClose={closePaymentPopup} />}

      {showDashboard && <Dashboard onClose={() => setShowDashboard(false)} />}

      {/* Banner between the Bit Tanks game card and the retro dog cards; gated
          on gameMode like both neighbors so it never shows without them */}
      {gameMode && <AAdsBanner />}

      {gameMode && (
        <Box id="dogsprite" sx={{ scrollMargin: '100px', padding: 0, marginBottom: '-20px' }}>
          <DogSprite />
        </Box>
      )}
      <TickerTapeComponent content={tickerContent} />

      {/* Final banner: under the bottom ticker, above the footer links */}
      <AAdsBanner />

      <FooterBar>
        <FooterLink
          component="a"
          onClick={(e) => {
            // Play the sound first
            if (aboutAudioRef.current) {
              aboutAudioRef.current.currentTime = 0;
              aboutAudioRef.current.play().catch(error => console.log('Error playing sound:', error));
            }

            // Navigate to the about page
            window.location.href = '/about';
          }}
          sx={{ cursor: 'pointer' }}
        >
          About
        </FooterLink>
        <Separator>/</Separator>
        <FooterLink
          component="a"
          href="https://www.satoshiadvance.com/privacy-policy"
          sx={{ cursor: 'pointer' }}
        >
          Privacy
        </FooterLink>
        <Separator>/</Separator>
        <FooterLink
          component="a"
          onClick={(e) => {
            e.preventDefault();
            // Check if user is authenticated
            if (isAuthenticated) {
              window.location.href = '/store';
            } else {
              // Prompt user to login/signup
              setSignUpContext('shop');
              setIsSignUpOpen(true);
            }
          }}
          sx={{ cursor: 'pointer' }}
        >
          Shop
        </FooterLink>
      </FooterBar>



      {isSignUpOpen && (
        <AuthPopup 
          onClose={() => {
            setIsSignUpOpen(false);
            setSignUpContext('');
          }} 
          fromShop={signUpContext === 'shop'}
        />
      )}

    </Box>
  );
};

export default PriceDisplay;

